<!-- eslint-disable vue/no-v-html -->
<template>
    <div :id="'ODON_'+identificadorUnico" class=" canvas p-2">
      <div :id="'CANVAS_ODON_'+identificadorUnico" style="width: 1500px; height: 700px;"></div>
    </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import type {  IConfOdontogramas } from '@/modules/Configuracion/interfaces'
import type { IFormComponent } from '@/modules/Administracion/interfaces'

const props = defineProps<{
  ciadId: number,
  cittId: number,
  odontograma: IConfOdontogramas,
  isView?: boolean
  comp?: IFormComponent
  xml: string
  dibujarEnElDOM: (id: string, xml: string, odontograma: IConfOdontogramas, cittId: number, print: boolean, isView?: boolean) => void
}>()
const { odontograma, cittId, isView = false, dibujarEnElDOM, xml } = props
const identificadorUnico = odontograma.coodId + '_' + cittId

onMounted(async () => {
  if (xml && document.getElementById('CANVAS_ODON_' + identificadorUnico)) {
    dibujarEnElDOM('#CANVAS_ODON_' + identificadorUnico, xml, props.odontograma, props.cittId, false, isView)
  }
})
</script>
<style scoped>
.canvas {
  width: 1200px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
</style>
